import tw from 'twin.macro';

// create common element here and extend it where needed
export const MenuItemFirstLevel = [
  tw`w-full`,
  tw`text-md font-medium`,
  tw`px-4 py-2`,
  tw`hover:bg-menu-hover hover:text-link-dark`,
];
